import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";
import { MeddreamSection } from "@/features/dashboard/sources/meddream";

/**
 * Vista completa de métricas del visor MedDream.
 */
export default function VisorMetrics(): React.JSX.Element {
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center gap-3">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/dashboard">
            <ArrowLeft className="mr-1.5 h-4 w-4" />
            Volver al overview
          </Link>
        </Button>
      </div>
      <MeddreamSection />
    </div>
  );
}
